import React from "react";

// ASSETS
import IntegratedSystemIcon from "assets/svg/IntegratedSystemIcon.svg";
import CoordinationIcon from "assets/svg/CoordinationIcon.svg";
import EfficiencyIcon from "assets/svg/EfficiencyIcon.svg";

// STYLES
import {
  MissionSectionCarouselContainer,
  MissionSectionCarouselContainerMobile,
  MissionSectionCarouselItem,
  MissionSectionCarouselItemIcon,
  MissionSectionCarouselItemIconWrapper,
  MissionSectionCarouselItemTextWrapper,
  MissionSectionCarouselItemTitleWrapper,
  MissionSectionCarouselItemWrapper,
  MissionSectionContainer,
  MissionSectionTextWrapper,
  MissionSectionTitleWrapper,
} from "./MissionSectionStyled";

// LIBRARIES
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";

// MISC
import { IProps } from "./MissionSectionModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";

// REDUX

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";

const MissionSection = (props: IProps) => {
  // PROPERTIES

  // LIBRARY CONSTANTS
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { t } = useTranslation();
  // STATE CONSTANTS
  const carouselItems = [
    {
      id: 1,
      title: t(
        "view.about.aboutDSU.missionSection.carouselItems.firstItem.title"
      ),
      text: t(
        "view.about.aboutDSU.missionSection.carouselItems.firstItem.text"
      ),
      icon: IntegratedSystemIcon,
    },
    {
      id: 2,
      title: t(
        "view.about.aboutDSU.missionSection.carouselItems.secondItem.title"
      ),
      text: t(
        "view.about.aboutDSU.missionSection.carouselItems.secondItem.text"
      ),
      icon: CoordinationIcon,
    },
    {
      id: 3,
      title: t(
        "view.about.aboutDSU.missionSection.carouselItems.thirdItem.title"
      ),
      text: t(
        "view.about.aboutDSU.missionSection.carouselItems.thirdItem.text"
      ),
      icon: EfficiencyIcon,
    },
  ];
  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <MissionSectionContainer>
      <MissionSectionTitleWrapper>
        <CustomText
          text={t("view.about.aboutDSU.missionSection.title")}
          type={TextType.H2}
          color={COLORS.VividAuburn}
        />
      </MissionSectionTitleWrapper>
      <MissionSectionTextWrapper>
        <CustomText
          text={t("view.about.aboutDSU.missionSection.text")}
          type={TextType.P1}
          color={COLORS.RaisinBlack}
        />
      </MissionSectionTextWrapper>
      {!isMobile ? (
        <MissionSectionCarouselContainer>
          {carouselItems.map((item) => (
            <MissionSectionCarouselItemWrapper
              key={`carousel-item--${item.id}`}
            >
              <MissionSectionCarouselItem>
                <MissionSectionCarouselItemTitleWrapper>
                  <CustomText
                    text={item?.title}
                    type={TextType.P2}
                    color={COLORS.Yellow}
                  />
                </MissionSectionCarouselItemTitleWrapper>
                <MissionSectionCarouselItemTextWrapper>
                  <CustomText
                    text={item?.text}
                    type={TextType.P2}
                    color={COLORS.Background}
                  />
                </MissionSectionCarouselItemTextWrapper>
                <MissionSectionCarouselItemIconWrapper>
                  <MissionSectionCarouselItemIcon src={item?.icon} />
                </MissionSectionCarouselItemIconWrapper>
              </MissionSectionCarouselItem>
            </MissionSectionCarouselItemWrapper>
          ))}
        </MissionSectionCarouselContainer>
      ) : (
        <MissionSectionCarouselContainerMobile>
          <Slider
            infinite={false}
            speed={500}
            slidesToShow={1}
            slidesToScroll={1}
            arrows={false}
            centerMode={true}
            centerPadding="40px"
          >
            {carouselItems.map((item) => (
              <MissionSectionCarouselItemWrapper
                key={`carousel-item--${item.id}`}
              >
                <MissionSectionCarouselItem>
                  <MissionSectionCarouselItemTitleWrapper>
                    <CustomText
                      text={item?.title}
                      type={TextType.P2}
                      color={COLORS.Yellow}
                    />
                  </MissionSectionCarouselItemTitleWrapper>
                  <MissionSectionCarouselItemTextWrapper>
                    <CustomText
                      text={item?.text}
                      type={TextType.P2}
                      color={COLORS.Background}
                    />
                  </MissionSectionCarouselItemTextWrapper>
                  <MissionSectionCarouselItemIconWrapper>
                    <MissionSectionCarouselItemIcon src={item?.icon} />
                  </MissionSectionCarouselItemIconWrapper>
                </MissionSectionCarouselItem>
              </MissionSectionCarouselItemWrapper>
            ))}
          </Slider>
        </MissionSectionCarouselContainerMobile>
      )}
    </MissionSectionContainer>
  );
};

export default MissionSection;
